define('bundles/common-ui-clean',['require'],function(require) {

  function init(callback) {
    coreDependencies(callback);
  }

  function coreDependencies(callback) {
    // Core dependencies, that needs to be loaded before the rest

    require([], function() {
      loadCommonDependencies(callback);
    });

  }

  function loadCommonDependencies(callback) {

    require([
      'lib/Podio.UI.FlashMessage'
    ], function() {

      initializeComponents();
      callback();

    });

  }

  function initializeComponents() {
  }

  return {
    init: init
  };

});

